module.exports = __webpack_public_path__ + "static/OCRB-985c06dacaa4dd9330acc93533d301b8.ttf";